module.exports = __webpack_public_path__ + "img/page_item2.7857b339.png";